/*--------------------------------------
	공휴일 관리 (설정 > 공휴일 관리)
	목록 클릭 → 편집 폼 채움 / 저장·삭제(ajax) 후 그 해 목록으로.
	라우트: /adm/holidays, /adm/ajax/holidays/{save,delete}
--------------------------------------*/
export default class Holiday {
	initialize(){
		const self = this;
		$(document).off('.holiday');

		$(document).on('change.holiday', '#holidayYear', function(){ self.goYear($(this).val()); });
		$(document).on('click.holiday', '.js-holiday-row', function(){ self.load($(this)); });
		$(document).on('click.holiday', '.js-holiday-new', function(){ self.clear(); });
		$(document).on('click.holiday', '.js-holiday-save', function(){ self.save(); });
		$(document).on('click.holiday', '.js-holiday-del', function(){ self.remove(); });
	}

	goYear(year){
		location.replace('/adm/holidays?year=' + encodeURIComponent(year));
	}

	load($tr){
		$('#holidayOrigDate').val($tr.attr('data-date'));
		$('#holidayDate').val($tr.attr('data-date'));
		$('#holidayName').val($tr.attr('data-name'));
		$('#holidayType').val($tr.attr('data-type'));
		$('.js-holiday-del').prop('disabled', false);

		$('#holidayTable .js-holiday-row').removeClass('table-active');
		$tr.addClass('table-active');
	}

	clear(){
		$('#holidayOrigDate').val('');
		$('#holidayDate').val('');
		$('#holidayName').val('');
		$('#holidayType').prop('selectedIndex', 0);
		$('.js-holiday-del').prop('disabled', true);
		$('#holidayTable .js-holiday-row').removeClass('table-active');
		$('#holidayDate').trigger('focus');
	}

	save(){
		const self = this;
		const holiday_date = $('#holidayDate').val();
		const name = $.trim($('#holidayName').val());
		if( !holiday_date ){ $j.Ui.Dialog.alert('날짜를 입력하세요.'); return; }
		if( !name ){ $j.Ui.Dialog.alert('이름을 입력하세요.'); return; }

		$.ajax({
			type: 'post', url: '/adm/ajax/holidays/save', dataType: 'json',
			data: {
				orig_date: $('#holidayOrigDate').val(),
				holiday_date,
				name,
				type: $('#holidayType').val()
			},
			success: function(res){
				if( res && res.result ) self.goYear(res.year);
				else $j.Ui.Dialog.alert((res && res.msg) || '저장에 실패했습니다.');
			},
			error: function(){ $j.Ui.Dialog.alert('저장 중 오류가 발생했습니다.'); }
		});
	}

	async remove(){
		const self = this;
		const holiday_date = $('#holidayOrigDate').val();
		if( !holiday_date ) return;
		if( !(await $j.Ui.Dialog.confirm(holiday_date + ' 공휴일을 삭제할까요?')) ) return;

		$.ajax({
			type: 'post', url: '/adm/ajax/holidays/delete', dataType: 'json',
			data: { holiday_date },
			success: function(res){
				if( res && res.result ) self.goYear(holiday_date.slice(0, 4));
				else $j.Ui.Dialog.alert((res && res.msg) || '삭제에 실패했습니다.');
			},
			error: function(){ $j.Ui.Dialog.alert('삭제 중 오류가 발생했습니다.'); }
		});
	}
}
